export const SLACK_HREF = "https://app.slack.com/client/E086B9P9JM9/CB94AEYM9";
export const GITHUB_HREF = "https://github.com/equinor/webviz";
export const VIVA_ENGAGE_HREF =
    "https://engage.cloud.microsoft/main/groups/eyJfdHlwZSI6Ikdyb3VwIiwiaWQiOiIxMzM5NzE0NyJ9/all";
export const SERVICE_NOW_HREF =
    "https://equinor.service-now.com/selfservice?id=sc_cat_item&sys_id=7007cccac334ea100090dadf050131d2&sysparm_business_application=7d404bd21b602090670c553d6e4bcbf5";
